// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  StatsTable
}                         from '../../components';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';

class Marketing extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
      fetchEarningGraphDataIfNeeded:  PropTypes.func,
      fetchTeamMatesDataIfNeeded:     PropTypes.func,
      fetchStatsWidgetDataIfNeeded:     PropTypes.func,
      fetchStatsWidget2DataIfNeeded:     PropTypes.func,
      fetchStatsCardDataIfNeeded:       PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      
    }
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Marketing');
  }

  componentDidMount() {
    const {
      actions: {
        fetchEarningGraphDataIfNeeded,
        fetchTeamMatesDataIfNeeded,
        fetchStatsWidgetDataIfNeeded,
        fetchStatsWidget2DataIfNeeded,
        fetchStatsCardDataIfNeeded,
        fetchStatsTableDataIfNeeded
      }
    } = this.props;

    // fetchEarningGraphDataIfNeeded();
    // fetchStatsCardDataIfNeeded();
    // fetchStatsTableDataIfNeeded();
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Marketing');
  }

  render() {
    const {
      statsTable
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    return(

      <div>
        <div className='row'>
          <div className="col-md-2" style={{float: 'right'}}>
              <Link to={`./crud/AddPlace`} target="_blank">
              <FlatButton
                backgroundColor="#c6ff00"
                label="Add Places"
                style={{marginLeft: '10px', }}
              />
              </Link>
          </div>
        </div> 

        <div className="row" style={{marginTop:10}}>
          <StatsTable bigTable={true} name="place_list" displayName="Nearby Places List" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
        </div>
      </div>
    );
  }
}

export default Marketing;



// WEBPACK FOOTER //
// ./src/app/views/marketing/Marketing.js